export default () => {

    let tab = $('.rates-table-tabs__el');

    if (!tab) return;

    tab.on('click', (e) => {
        let self = e.target;
        let parent = $(self).parent();
        let element;

        if ($(self).hasClass('rates-table-tabs__el')) {
            element = $(self);
        }

        if (parent.hasClass('rates-table-tabs__el')) {
            element = parent;
        }

        if (!element.hasClass('active')) {
            let selectedTab = element.attr('data-tab');
            let activeElement = element.parent().find('.active');
            let activeElementTab = activeElement.attr('data-tab');
            let selectedTable = $(`.rates-table-wrapper.pricing-wrapper[data-table="${selectedTab}"]`);
            let activeTable = $(`.rates-table-wrapper.pricing-wrapper[data-table="${activeElementTab}"]`);

            activeElement.removeClass('active');

            element.addClass('active');

            if (activeTable.hasClass('active')) {
                activeTable.removeClass('active');
            }

            selectedTable.addClass('active');

        }
    });
}